import { render, staticRenderFns } from "./WorkspaceGraphViewOptionsMenu.vue?vue&type=template&id=fb462308&scoped=true"
import script from "./WorkspaceGraphViewOptionsMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceGraphViewOptionsMenu.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGraphViewOptionsMenu.vue?vue&type=style&index=0&id=fb462308&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb462308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb462308')) {
      api.createRecord('fb462308', component.options)
    } else {
      api.reload('fb462308', component.options)
    }
    module.hot.accept("./WorkspaceGraphViewOptionsMenu.vue?vue&type=template&id=fb462308&scoped=true", function () {
      api.rerender('fb462308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGraphViewOptionsMenu.vue"
export default component.exports